"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./IconTextList.scss");
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconTextList = _ref => {
  let {
    contentfulId,
    items,
    theme,
    disableIcon,
    paddingClass
  } = _ref;
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    backgroundColor,
    color,
    iconColor,
    theme: themeName
  } = (0, _useStyles.default)(themes);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-icon-text-list ${paddingClass}`,
    style: {
      background: backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-icon-text-list__content-wrapper",
    style: {
      color: color
    },
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, items && items?.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-object-id": item?.contentfulId ? item?.contentfulId : null,
      className: "ter-icon-text-list__item",
      key: index
    }, !disableIcon && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-icon-text-list__item-icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "ter-icon-text-list__item-icon-type",
      size: "48px",
      type: item?.icon,
      color: iconColor,
      sbProps: item?.contentfulId ? {
        "data-sb-field-path": "textItemIcon"
      } : null
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-icon-text-list__item-text"
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-field-path": item?.contentfulId ? "headline" : null,
      className: "ter-icon-text-list__item-text-headline",
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(item?.headline)
    }), /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-field-path": item?.contentfulId ? "body" : null,
      className: `ter-icon-text-list__item-text-body ter-icon-text-list__bullet-theme--${themeName}`,
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(item?.body)
    })));
  })));
};
var _default = IconTextList;
exports.default = _default;